export const QUERY_KEYS = {
  ADVERTISER_INSERTION_ORDERS: 'advertiserInsertionOrders',
} as const;
